import { Navigate } from 'react-router-dom';
import { IS_SA } from '../config/appConfig';
import { AppRoutes } from '../constants/appRoutes';
import { InvestorStatus } from '../constants/investorStatus';
import { Roles } from '../constants/roles';
import { getCurrentUserPath } from '../helpers/authHelper';
import { buildLocalizeRoute } from '../helpers/languageHelper';
import { checkIsBorrowerOrInvestor } from '../helpers/loginCheckHelper';
import {
	getRegistrationData,
	getRegistrationInfo,
	getUser
} from '../services/authService';

export const InvestorRole = ({ children }) => {
	const user = getUser();
	const registrationData = getRegistrationInfo();
	if (user && user?.role === Roles.Investor) {
		let investorStep = registrationData?.investorStep;
		if (!investorStep || investorStep < 3 || !registrationData) {
			let route = checkIsBorrowerOrInvestor(registrationData, user);
			<Navigate
				to={buildLocalizeRoute(route)}></Navigate>;
		}
		return children;
	}
	if (!user) {
		const { returnUrl, region } = getReturnUrl();
		return (
			<Navigate
				to={buildLocalizeRoute(
					`${AppRoutes.Login}/?returnUrl=${returnUrl}`, region
				)}></Navigate>
		);
	}

	return <Navigate to={buildLocalizeRoute('')}></Navigate>;
};

export const BorrowerRole = ({ children }) => {
	const user = getUser();
	if (user && user?.role === Roles.Borrower) {
		if (!user?.isApproved) {
			<Navigate
				to={buildLocalizeRoute(
					`${AppRoutes.Borrower}/${AppRoutes.ThankYou}`
				)}></Navigate>;
		}
		return children;
	}

	return <Navigate to={buildLocalizeRoute('')}></Navigate>;
};

export const CheckProfileAuth = ({ children }) => {
	if (getUser()) {
		return children;
	}
	const { returnUrl, region } = getReturnUrl();
	return (
		<Navigate
			to={buildLocalizeRoute(
				`${AppRoutes.Login}/?returnUrl=${returnUrl}`, region
			)}></Navigate>
	);
};

export const CheckLogin = ({ children }) => {
	const user = getUser();
	let isCheckApproved = user?.role === Roles.Investor ? true : user?.isApproved;

	if (user?.role === Roles.Borrower && user?.status === InvestorStatus.WindDown) {
		return <Navigate to={buildLocalizeRoute(`${AppRoutes.WindDown}`)}></Navigate>;
	}

	if (user?.status === InvestorStatus.Archived && user?.role === Roles.Investor) {
		return <Navigate to={buildLocalizeRoute(`${AppRoutes.Investor}/${AppRoutes.ThankYou}`)}></Navigate>;
	}

	if (!user?.OtpVerified || !isCheckApproved) {
		const { returnUrl, region } = getReturnUrl();
		return (
			<Navigate
				to={buildLocalizeRoute(
					`${AppRoutes.Login}/?returnUrl=${returnUrl}`, region
				)}></Navigate>
		);
	}

	if (isCheckApproved) {
		const registrationData = getRegistrationInfo();
		if (user && user?.role === Roles.Investor) {
			let investorStep = registrationData?.investorStep;
			if (!investorStep || investorStep < 3 || !registrationData) {
				let route = checkIsBorrowerOrInvestor(registrationData, user);
				return <Navigate
					to={buildLocalizeRoute(route)}></Navigate>;
			}
		}
	}

	return children;
};

const getReturnUrl = () => {
	const requestedHref = `${document.location.pathname}${document.location.search}`;
	const hasSAinUrl = requestedHref.split('/sa/').length;
	const returnLangUrl =
		hasSAinUrl.length > 1 ? requestedHref.split('/sa')[1] : requestedHref;
	const returnUrl = returnLangUrl?.includes('/en/')
		? returnLangUrl.split('/en/')[1]
		: returnLangUrl.includes('/ar/')
			? returnLangUrl.includes('/ar/')[1]
			: returnLangUrl;
	return {
		returnUrl: returnUrl,
		region: hasSAinUrl.length > 1 ? 'sa' : 'ae'
	};
};

export const ThankYouPageGuard = ({ children }) => {
	const user = getUser();
	if (user) {
		return children;
	}
	const { returnUrl, region } = getReturnUrl();
	return (
		<Navigate
			to={buildLocalizeRoute(
				`${AppRoutes.Login}/?returnUrl=${returnUrl}`, region
			)}></Navigate>
	);
};

export const InvestorTransferGuard = ({ children }) => {
	const user = getUser();
	if (user?.isApproved || user?.status === InvestorStatus.WindDown) {
		return children;
	}
	return <Navigate to={buildLocalizeRoute(AppRoutes.Investor)}></Navigate>;
};

export const AlreadyLogin = ({ children }) => {
	const user = getUser();
	const regInfo = getRegistrationInfo();
	if (!user) {
		return children;
	}

	if (!regInfo) {
		if (user?.role === Roles.Investor) {
			return IS_SA ? (
				<Navigate
					to={buildLocalizeRoute(
						`${AppRoutes.InvestorRegistration}/${AppRoutes.IRegNafathVerification}`
					)}></Navigate>
			) : (
				<Navigate
					to={buildLocalizeRoute(
						`${AppRoutes.InvestorRegistration}/${AppRoutes.IRegPersonalInfo}`
					)}></Navigate>
			);
		} else if (user?.role === Roles.Borrower) {
			return (
				<Navigate
					to={buildLocalizeRoute(
						`${AppRoutes.BorrowerRegistartion}/${AppRoutes.BRegPersonalInfo}`
					)}></Navigate>
			);
		}
	}

	if (user && regInfo) {
		let route = checkIsBorrowerOrInvestor(regInfo, user);
		if (route) {
			return <Navigate to={buildLocalizeRoute(route)}></Navigate>;
		}

		if (user?.isApproved) {
			return <Navigate to={getCurrentUserPath()}></Navigate>;
		} else {
			if (user?.status === InvestorStatus.WindDown) {
				return (
					<Navigate to={buildLocalizeRoute(AppRoutes.WindDown)}></Navigate>
				);
			}
			if (user?.role === Roles.Investor) {
				if (regInfo?.investorStep === 3) {
					return <Navigate to={getCurrentUserPath()}></Navigate>;
				}
			} else {
				let thankYouUrl = `${AppRoutes.Borrower}/${AppRoutes.ThankYou}`;
				return <Navigate to={buildLocalizeRoute(thankYouUrl)}></Navigate>;
			}

		}
	}
	return children;
};

export const RegistrationLoginCheck = ({ children }) => {
	const user = getUser();
	if (!user) {
		return children;
	}

	if ((user?.status && user?.status !== 'InComplete') || user?.isApproved) {
		const { returnUrl, region } = getReturnUrl();
		return (
			<Navigate
				to={buildLocalizeRoute(
					`${AppRoutes.Login}/?returnUrl=${returnUrl}`, region
				)}></Navigate>
		);
	}

	return children;
};

export const NafathVerificationGuard = ({ children }) => {
	const user = getUser();
	const regInfo = getRegistrationInfo();
	const regData = getRegistrationData();
	if (user) {
		if (user.role === Roles.Investor) {
			if (regInfo?.investorStep > 0 || regData?.step > 0) {
				return (
					<Navigate
						to={buildLocalizeRoute(
							`${AppRoutes.InvestorRegistration}/${AppRoutes.IRegPersonalInfo}`
						)}></Navigate>
				);
			}
			return children;
		} else if (user.role === Roles.Borrower) {
			if (regInfo?.borrowerStep > 0 || regData?.step > 0) {
				let route = IS_SA
					? AppRoutes.CommercialRegistration
					: AppRoutes.BRegPersonalInfo;
				return (
					<Navigate
						to={buildLocalizeRoute(
							`${AppRoutes.BorrowerRegistartion}/${route}`
						)}></Navigate>
				);
			}
			return children;
		}
	}
	const { returnUrl, region } = getReturnUrl();
	return (
		<Navigate
			to={buildLocalizeRoute(
				`${AppRoutes.Login}/?returnUrl=${returnUrl}`, region
			)}></Navigate>
	);
};

export const UserNafathGuard = ({ children }) => {
	if (IS_SA) {
		return children;
	}

	return (
		<Navigate to={buildLocalizeRoute(`${AppRoutes.Investor}`)}></Navigate>
	);
};

export const KSATransferGuard = ({ children }) => {
	if (IS_SA) {
		return children;
	}

	return (
		<Navigate to={buildLocalizeRoute(`${AppRoutes.Investor}/${AppRoutes.ITransfer}/${AppRoutes.IDeposit}`)}></Navigate>
	);
};